import axios from 'axios';
import Alert from '@mui/lab/Alert';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import Loader from 'react-loader-spinner';
import { useHistory } from 'react-router';
import Button from '@mui/material/Button';
import { useParams } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import React, { useState, useCallback, useEffect } from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { classes } from '../styles';
import DashboardNavBar from '../../../components/Dashboard/Common/Navbar';
import DashboardSideMenu from '../../../components/Dashboard/Common/SidebarMenu';

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem('lhcfToken');

const DashboardEditDonationPage = () => {
  const history = useHistory();
  const { donationId } = useParams();

  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    warningOpen: false,
    errorOpen: false,
    successOpen: false,
    vertical: 'center',
    horizontal: 'center',
  });
  const [donation, setDonation] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    amount: '',
    message: '',
    stripeChargeId: '',
    stripeReceiptUrl: '',
    paid: false,
  });

  const { successOpen, errorOpen, vertical, horizontal } = snackbarState;

  const handleClose = () => {
    setSnackbarState({
      ...snackbarState,
      errorOpen: false,
      successOpen: false,
    });
  };

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      href="/dashboard"
      onClick={() => history.push('/dashboard')}
    >
      Dashboard
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      href="/dashboard/general-donations/"
      onClick={() => history.push('/dashboard/general-donations')}
    >
      General Donations
    </Link>,
    <Typography key="3" color="text.primary">
      Update Donation
    </Typography>,
  ];

  const handleInputChange = (e) => {
    const key = e.target.name;
    const value = key === 'paid' ? e.target.checked : e.target.value;

    setDonation({ ...donation, [key]: value });
  };

  const handleSubmission = (e) => {
    e.preventDefault();

    setUpdateLoading(true);

    const payload = {
      firstName: donation.firstName,
      lastName: donation.lastName,
      email: donation.email,
      address: donation.address,
      amount: donation.amount,
      message: donation.message,
      stripeChargeId: donation.stripeChargeId,
      stripeReceiptUrl: donation.stripeReceiptUrl,
      paid: donation.paid,
    };

    axios
      .put(`${baseUrl}/donation/${donationId}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data: { data } }) => {
        setSnackbarState({ ...snackbarState, successOpen: true });
        setUpdateLoading(false);
        setDonation(data);
      })
      .catch((err) => {
        setSnackbarState({ ...snackbarState, errorOpen: true });
        setUpdateLoading(false);
      });
  };

  const fetchDonation = useCallback((donationId) => {
    axios
      .get(`${baseUrl}/donation/${donationId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data: { data } }) => {
        setDonation(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoadingError(true);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchDonation(donationId);
  }, [fetchDonation, donationId]);

  return (
    <Box sx={classes.container}>
      <DashboardNavBar />
      <DashboardSideMenu />
      {/* PAGE */}
      <Box sx={classes.pageContainer}>
        <Snackbar
          open={errorOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            Could not update the donation. Try again.
          </Alert>
        </Snackbar>
        <Snackbar
          open={successOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: '100%' }}
          >
            Donation updated successfully!
          </Alert>
        </Snackbar>
        {loading ? (
          <Box sx={classes.commonMargin}>
            <Loader type="Oval" color="#B40404" height={80} width={80} />
          </Box>
        ) : loadingError ? (
          <Box sx={classes.commonMargin}>
            <Typography variant="subtitle1" component="div">
              Could not fetch the donation. Refresh or check back later.
            </Typography>
          </Box>
        ) : (
          <>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
            <Box
              sx={classes.paperContainer}
              component="form"
              onSubmit={handleSubmission}
            >
              <Paper elevation={4} variant="outlined" square>
                <TextField
                  id="filled-basic"
                  label="Donator First Name"
                  name="firstName"
                  variant="filled"
                  value={donation.firstName}
                  onChange={handleInputChange}
                  required
                  sx={classes.commonTextFieldWidth}
                />

                <br />
                <br />

                <TextField
                  id="filled-basic"
                  label="Donator Last Name"
                  name="lastName"
                  variant="filled"
                  value={donation.lastName}
                  onChange={handleInputChange}
                  required
                  sx={classes.commonTextFieldWidth}
                />

                <br />
                <br />

                <TextField
                  id="filled-basic"
                  label="Donator Email"
                  name="email"
                  variant="filled"
                  value={donation.email}
                  onChange={handleInputChange}
                  required
                  sx={classes.commonTextFieldWidth}
                  type="email"
                />

                <br />
                <br />

                <TextField
                  id="filled-basic"
                  label="Donator Address"
                  name="address"
                  variant="filled"
                  value={donation.address}
                  onChange={handleInputChange}
                  required
                  sx={classes.commonTextFieldWidth}
                />

                <br />
                <br />

                <TextField
                  id="filled-basic"
                  label="Donated Amount ($)"
                  name="amount"
                  variant="filled"
                  value={donation.amount}
                  onChange={handleInputChange}
                  required
                  sx={classes.commonTextFieldWidth}
                  type="number"
                />

                <br />
                <br />

                <TextField
                  id="standard-multiline-static"
                  label="Donator Message"
                  name="message"
                  variant="filled"
                  multiline
                  rows={5}
                  value={donation.message}
                  onChange={handleInputChange}
                  required
                  sx={classes.commonTextFieldWidth}
                />

                <br />
                <br />

                <TextField
                  id="filled-basic"
                  label="Stripe Charge ID"
                  name="stripeChargeId"
                  variant="filled"
                  value={donation.stripeChargeId}
                  onChange={handleInputChange}
                  sx={classes.commonTextFieldWidth}
                />

                <br />
                <br />

                <TextField
                  id="standard-multiline-static"
                  label="Stripe Receipt URL"
                  name="stripeReceiptUrl"
                  variant="filled"
                  multiline
                  rows={5}
                  value={donation.stripeReceiptUrl}
                  onChange={handleInputChange}
                  sx={classes.commonTextFieldWidth}
                />

                <br />
                <br />
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '60px',
                    marginBottom: '15px',
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    component="div"
                    style={{ lineHeight: 2.4 }}
                  >
                    Paid:
                  </Typography>
                  <Switch
                    name="paid"
                    checked={donation.paid}
                    onChange={handleInputChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                    color="primary"
                  />
                </Box>

                <br />
                <br />

                <Box sx={classes.buttonsContainer}>
                  {updateLoading ? (
                    <Button variant="contained" color="primary" disabled>
                      <Loader
                        type="Oval"
                        color="#1976d2"
                        height={30}
                        width={50}
                      />
                    </Button>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={classes.buttonMargin}
                        type="submit"
                      >
                        Update
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() =>
                          history.push('/dashboard/general-donations')
                        }
                      >
                        Cancel
                      </Button>
                    </>
                  )}
                </Box>
              </Paper>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default DashboardEditDonationPage;
